import { trim } from 'lodash';
import { mixed, object, string } from 'yup';

import { ConversationSelectType } from '../../../../../data/data/conversations/enums';
import { messages } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    patientId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    conversationType: mixed<ConversationSelectType>()
      .oneOf(Object.values(ConversationSelectType))
      .required(messages.required.id)
      .default(ConversationSelectType.EXISTING),
    conversationId: string()
      .transform(trim)
      .when('conversationType', {
        is: (conversationType: ConversationSelectType) =>
          conversationType === ConversationSelectType.EXISTING,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default(''),
    conversationTitle: string()
      .transform(trim)
      .when('conversationType', {
        is: (conversationType: ConversationSelectType) =>
          conversationType === ConversationSelectType.NEW,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default(''),
  })
  .required()
  .noUnknown();
